import React from 'react';
import PropTypes from 'prop-types';

import TextCell from 'app/components/data-table/TextCell';

export default function DebuggerAccessCell({ hasDebuggerAccess }) {
  const text = hasDebuggerAccess ? 'Yes' : '-';

  return <TextCell text={text} />;
}

DebuggerAccessCell.propTypes = {
  hasDebuggerAccess: PropTypes.bool,
};
